// extracted by mini-css-extract-plugin
export default {"bgContainer":"Modal_bgContainer__rPgDH","wrapper":"Modal_wrapper__yRSKI","modal":"Modal_modal__04nZs","exit":"Modal_exit__MPS7L"};